import { h, render, reactive } from 'vue';
import type { App } from 'vue';
import { useNotifications } from '@/composables/notifications';
import Renderer from './Renderer.vue';

const notify = useNotifications().notify
window.legacyNotifications = reactive(window.legacyNotifications || []);

let isPluginInstalled = false;
let rendererContainer: HTMLDivElement | null = null;
const patchedApps = new WeakSet<App>();

function unmountRenderer() {
    if (rendererContainer) {
        render(null, rendererContainer);
        rendererContainer.remove();
        rendererContainer = null;
    }

    isPluginInstalled = false;
}

export const notifyPlugin = {
    install(app: App) {
        app.config.globalProperties.$notify = notify;
        app.provide('notify', notify);

        if (!patchedApps.has(app)) {
            const originalUnmount = app.unmount.bind(app);
            app.unmount = () => {
                unmountRenderer();
                originalUnmount();
            };
            patchedApps.add(app);
        }

        if (!isPluginInstalled) {
            isPluginInstalled = true;

            rendererContainer = document.createElement('div');
            document.body.appendChild(rendererContainer);

            const vnode = h(Renderer, {
                legacyNotifications: window.legacyNotifications,
                'onClear:legacyNotifications': () => {
                    window.legacyNotifications.length = 0;
                },
            });
            vnode.appContext = (app as any)._context;
            render(vnode, rendererContainer);
        }
    },
};
